<template>
  <div></div>
</template>

<script>
import helpers from "@/helpers"
import { baseApiUrl } from "@/global"
import axios from "axios"
import xlsx from "xlsx"

export default {
  data() {
    return {
      importation: [],
      selectedProducts: [],
      selectedProductsSanitized: [],
    }
  },
  methods: {
    async generate(idImportation) {
      this.helpers = helpers

      await this.getImportation(idImportation)
      this.fixVarsToTable()
      if (!this.importation || !this.selectedProducts.length) return false
      this.makeXLSX()
      return true
    },
    async getImportation(idImportation) {
      try {
        this.$vs.loading()
        const response = await axios.get(`${baseApiUrl}/importation/${idImportation}/invoice`)
        this.importation = response.data.importation
        this.selectedProducts = response.data.selectedProducts
      } catch (error) {
        this.$vs.notify({
          title: 'Não foi possivel gerar o arquivo',
          text: error.response.data,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      } finally {
        this.$vs.loading.close()
      }
    },
    fixVarsToTable() {
      const helpers = this.helpers
      const selectedProducts = this.selectedProducts
      const selectedProductsSanitized = []
      let totalQuantity = 0
      let importationPrice = 0
      let importationNetWeight = 0

      for (const index in selectedProducts) {
        const product = selectedProducts[index]
        const unitPrice = helpers.moneyHelper.formatNumberToCurrency(product.precoMinimo, product.moeda)
        const totalPrice = (product.quantidade * product.precoMinimo).toFixed(2)
        const totalNetWeight = (product.quantidade * product.pesoLiquido).toFixed(2)

        totalQuantity += product.quantidade
        importationNetWeight += +totalNetWeight 
        importationPrice += +totalPrice

        selectedProductsSanitized.push({
          "ITEM": +index + 1,
          "CODE": product.codigo,
          "DESCRIPTION": product.descricaoEN,
          "BRAND": product.marca,
          "MODEL": product.modelo,
          "NCM": product.ncm,
          "Q'TY": product.quantidade,
          "UNIT": product.unidade,
          "NET WEIGHT": product.pesoLiquido,
          "TL NET WEIGHT": totalNetWeight,
          "PRICE/U USD": unitPrice,
          "TOTAL PRICE EXW NINGBO": helpers.moneyHelper.formatNumberToCurrency(totalPrice, product.moeda),
        })
      }
      selectedProductsSanitized.push({
        "ITEM": '',
        "CODE": '',
        "DESCRIPTION": '',
        "BRAND": '',
        "MODEL": '',
        "NCM": '',
        "Q'TY": totalQuantity,
        "UNIT": '',
        "NET WEIGHT": '',
        "TL NET WEIGHT": importationNetWeight.toFixed(2),
        "PRICE/U USD": '',
        "TOTAL PRICE EXW NINGBO": helpers.moneyHelper.formatNumberToCurrency(importationPrice, selectedProducts[0].moeda),
      })
      this.selectedProductsSanitized = selectedProductsSanitized
    },
    XLSXfitColumns(json, worksheet) {
      const jsonKeys = Object.keys(json[0]);

      let objectMaxLength = [];
      for (let i = 0; i < json.length; i++) {
        let value = json[i];
        for (let j = 0; j < jsonKeys.length; j++) {
          if (typeof value[jsonKeys[j]] == "number") {
            objectMaxLength[j] = 10;
          } else {

            const l = value[jsonKeys[j]] ? value[jsonKeys[j]].length : 0;

            objectMaxLength[j] =
              objectMaxLength[j] >= l ?
              objectMaxLength[j] :
              l;
          }
        }

        let key = jsonKeys;
        for (let j = 0; j < key.length; j++) {
          objectMaxLength[j] =
            objectMaxLength[j] >= key[j].length ?
            objectMaxLength[j] :
            key[j].length;
        }
      }
      const wscols = objectMaxLength.map(w => { return { width: w + 5 } });
      worksheet["!cols"] = wscols
    },
    makeXLSX() {
      const worksheet = xlsx.utils.json_to_sheet(this.selectedProductsSanitized)
      this.XLSXfitColumns(this.selectedProductsSanitized, worksheet)
      const workbook = xlsx.utils.book_new()
      xlsx.utils.book_append_sheet(workbook, worksheet, 'Planilha 1')
      const importation = this.importation
      const filename = `${importation.numeroImportacao} IMPORTAÇÃO ${importation.nomeCurto} - COMMERCIAL INVOICE`
      xlsx.writeFile(workbook, filename + '.xlsx')
    }
  }
}

</script>
